import launchpadPhoneImage from 'url:asset/bento/launchpad-phone.png';
import worshipSongsPhone from 'url:asset/bento/worship-songs.png';
import eventsImage from 'url:asset/launchpad/events.png';

export default function LaunchpadSection() {
  return <div className="py-16">
    <div className="md:w-3/4 px-16 w-full">
      <p className="font-semibold text-2xl md:text-3xl">Launchpad</p>
      <h1 className="font-semibold text-3xl md:text-5xl text-accent">Meet them where they're at.</h1>

      <p className="font-medium text-2xl md:text-3xl text-[#888888]">Salt automatically creates a Launchpad for your church — helping attendees connect with you, find Events, Worship Songs, and more.</p>
    </div>

    <div className="overflow-x-scroll snap-x snap-mandatory px-16 scroll-px-16 [scrollbar-width:none]">
      <div className="flex flex-row w-fit gap-8 mt-4">
        <FeatureCard
          title="Highlight important links."
          description="Place important links at the top of Launchpad, like a form to Get Connected, send a Prayer Request, or to Give."
          image={launchpadPhoneImage}
          imageAlignment='bottom'
        />

        <FeatureCard
          title="Share Events."
          description="Your events appear on Launchpad automatically, without lifting a finger. And they link right to any registration page of your choosing."
          image={eventsImage}
          imageAlignment='middle'
        />

        <FeatureCard
          title="Share Worship Songs."
          description="Salt finds worship songs across Apple Music, Spotify, and YouTube Music. Wherever someone listens, they can save your worship songs."
          image={worshipSongsPhone}
          imageAlignment='top'
        />
      </div>
    </div>
  </div>
}

function FeatureCard(
  props: {
    title: string,
    description: string,
    image: any,
    imageAlignment: "top" | "bottom" | "middle"
  }
) {
  let imgClass = `absolute absolute left-1/2 -translate-x-1/2 max-h-full object-contain`;

  if (props.imageAlignment === "top") {
    imgClass += " top-0 pb-8";
  } else if (props.imageAlignment === "bottom") {
    imgClass += " bottom-0 pt-8";
  } else {
    imgClass += " top-1/2 -translate-y-1/2";
  }

  return (
    <div className='w-75 mt-8 snap-center'>
      <div className="relative bg-white h-85 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.1)] rounded-4xl overflow-hidden">
        <img
          src={props.image}
          draggable={false}
          className={imgClass}
        />
      </div>

      <p className="mt-4 text-lg/snug">
        <span className="font-semibold">{props.title}</span>{" "}
        <span className='text-[#888888]'>{props.description}</span>
      </p>
    </div>
  )
}